module.exports = __webpack_public_path__ + "static/rocket-men-a6100042fd51cfa9ab860195403a838f.jpg";